<template>
  <div class="app-chrome">
    <loading-indicator v-if="isLoadingCurrentUser"></loading-indicator>
    <div v-else>
      <page403 v-if="isUnauthorize"></page403>
      <div class="page-content container" v-else>
        <!-- Panel -->
        <div class="panel">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-6">
                <h4>
                  <img class="margin-right-10" src="/static/images/byteark-logo-blue.png" title="ByteArk" height="60">
                </h4>
                <div class="m-t-20">
                  <p class="font-size-12 m-b-5">บริษัท ไบต์อาร์ค จำกัด</p>
                  <p class="font-size-12 m-b-5">เลขที่ 1 อาคารพร้อมพันธ์ 2 ชั้น 6 ห้อง 610</p>
                  <p class="font-size-12 m-b-5">ซอยลาดพร้าว 3 ถนนลาดพร้าว แขวงจอมพล</p>
                  <p class="font-size-12 m-b-5">เขตจตุจักร กรุงเทพมหานคร 10900</p>
                  <p class="font-size-12 m-b-5">เบอร์โทรศัพท์ 02-512-2826 โทรสาร 02-512-2827</p>
                </div>
              </div>
              <div class="col-md-6 text-xs-right">
                <h3 class="m-t-20 m-b-0">{{ $t("statement.labels.orderNumber") }}: {{statement.order_number}}</h3>
                <p class="font-size-18">{{ $t("clientUsageHistory.labels.dateIssued") }} : {{dateIssued}}</p>
                <p class="font-size-16">{{ $t("clientUsageHistory.labels.team") }}: {{team ? team.name : ''}}</p>
                <p class="font-size-16" v-if="team ? team.reseller_id != 0 : false"> Reseller : {{team.reseller.name }}</p>
              </div>
            </div>
            <div class="page-invoice-table table-responsive m-t-60">
              <table class="table table-hover text-right">
                <thead>
                  <tr>
                    <th>{{ $t("statement.labels.description") }}</th>
                    <th class="text-xs-right">{{ $t("statement.labels.amount") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="statement">
                    <td class="text-xs-left">{{statement.description}}</td>
                    <td class="text-xs-right">{{statement.human_amount}} {{ $t("billing.currencies.thb") }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="text-xs-right">
              <button type="button" class="btn btn-animate btn-animate-side btn-default btn-outline" onclick="javascript:window.print(); " v-if="!isPrinting">
                <span><i class="icon md-print" aria-hidden="true"></i> {{ $t("action.print") }}</span>
              </button>
            </div>
            <div class="m-t-40" v-if="billingInformation">
              <h4>{{billingInformation.first_name}} {{billingInformation.last_name}}</h4>
              <div class="m-b-5 m-t-10">
                <p v-if="team && team.is_reseller"><span class="p-r-10">{{billingInformation.company_name}}</span> {{ $t("billing.information.labels.taxID") }} : {{billingInformation.tax_id}}</p>
                <p>
                  <span class="address1">{{billingInformation.address1}}</span>
                  <span class="address2">{{billingInformation.address2}}</span>
                  <span class="city">{{billingInformation.city}}</span>
                  <span class="state">{{billingInformation.state}}</span>
                  <span class="postal-code">{{billingInformation.zipcode}}</span>
                  <span class="country">{{billingInformation.country}}</span>
                </p>
                <p>{{ $t("billing.information.labels.billingContactPhone") }} : {{billingInformation.contact_phone}}</p>
                <p>{{ $t("billing.information.labels.billingEmail") }} : {{billingInformation.contact_email}}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- End Panel -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import moment from 'moment';
import { Validator } from 'vee-validate';
import LoadingIndicator from 'components/LoadingIndicator';
import StorageManager from 'src/managers/StorageManager';

export default {
  props: [
    'data',
  ],
  components: {
    LoadingIndicator,
  },
  watch: {
    isLoadingCurrentUser: function() {
      this.checkAuthorize();
    },
    $route () {
      this.checkAuthorize();
    },
    currentUser: function() {
      if (this.currentUser) {
        const namespace = this.currentUser.team.namespace;

        this.$i18n.locale = this.currentUser.lang;

        Validator.setLocale(this.currentUser.lang);

        moment.locale(this.currentUser.lang);

        // check lang in local storage
        this.storage.getLang(namespace).then((lang) => {
          if (lang !== this.currentUser.lang) {
            this.storage.setLang(this.currentUser.lang, namespace);
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters([
      'isLoadingCurrentUser',
      'getCurrentUserError',
      'currentUser',
    ]),
    dateIssued: function () {
      if (this.statement && this.statement.created_at) {
        return moment(this.statement.created_at).format('D MMMM YYYY');
      }
      return '';
    },
  },
  data: function() {
    return {
      isUnauthorize: false,
      isPrinting: false,
      statement: {},
      billingInformation: {
        first_name: null,
        last_name: null,
        company_name: null,
        tax_id: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zipcode: null,
        country: null,
        contact_phone: null,
        contact_email: null,
      },
      team: null,
      reseller: null,
      storage: null,
    };
  },
  mounted: function() {
    this.fetchOrderNumberReport(this.$route.query.number);
  },
  created: function() {
    this.storage = new StorageManager();

    this.$store.dispatch('getCurrentUser');
  },
  methods: {
    checkAuthorize: function() {
      if (this.currentUser) {
        if (this.$route.matched.some(record => record.meta.requiresManager)) {
          if (this.currentUser.role !== 'manager' && !this.currentUser.team.is_superadmin) {
            //redirect 403
            // this.$router.push(`/${this.$route.params.namespace}/403`);
            this.isUnauthorize = true;
            return;
          }
        } else if (this.$route.matched.some(record => record.meta.requiresSuperAdmin)) {
          if (!this.currentUser.team.is_superadmin) {
            //redirect 403
            // this.$router.push(`/${this.$route.params.namespace}/403`);
            this.isUnauthorize = true;
            return;
          }
        }
      }
      this.isUnauthorize = false;
    },
    fetchOrderNumberReport: function(number) {
      let namespace = '';

      if (this.$route.params.subnamespace) {
        namespace = this.$route.params.subnamespace;
      } else {
        namespace = this.$route.params.namespace;
      }

      const url = `/api/teams/${namespace}/balances/transaction/${number}`;

      axios.get(url)
      .then((response) => {
        this.statement = response.data;
        this.team = this.statement ? this.statement.team : '';
        this.billingInformation = this.team ? this.team.active_billing_address : '';
      })
      .catch(() => {
      });
    },
  },
};
</script>
</script>

<style scoped>
h1 {
  font-size: 18rem;
}
h1 .icon:first-child {
  margin-right: 0;
}

@page
{
    size: A4;
    margin: 0mm;
}

</style>



// WEBPACK FOOTER //
// PageOrderNumberReport.vue?362c2cb0